import {z} from 'zod'
import {createNumericKeyRecordSchema} from '../OptionalNumericKeyRecordSchema.ts'
import {createPartialStrictObjectSchemaWithAtLeastOneProperty} from '../PartialStrictObjectSchema.ts'
import {validateState} from '../ValidateState.ts'

export enum TileHexType {
    Desert = 0,
    Lumber = 1,
    Brick = 2,
    Wool = 3,
    Grain = 4,
    Ore = 5,
    Gold = 6,
    Fog = 7,
    Sea = 8,
}

export const tileHexStateSchema = z
    .object({
        x: z.number().int().readonly(),
        y: z.number().int().readonly(),
        type: z.enum(TileHexType),
        diceNumber: z.number().int().min(2).max(12),
    })
    .strict()

export type TileHexState = z.infer<typeof tileHexStateSchema> & {
    readonly x: number
    readonly y: number
}

export function validateTileHexState(data: unknown) {
    return validateState(tileHexStateSchema, data)
}

export const tileHexStatesSchema = createNumericKeyRecordSchema(tileHexStateSchema)
export type TileHexStates = z.infer<typeof tileHexStatesSchema>

export function validateTileHexStates(data: unknown) {
    return validateState(tileHexStatesSchema, data)
}

export const tileHexStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(tileHexStateSchema)

export type TileHexStatePartial = z.infer<typeof tileHexStatePartialSchema> & {
    readonly x?: number
    readonly y?: number
}

export function validateTileHexStatePartial(data: unknown) {
    return validateState(tileHexStatePartialSchema, data)
}

export const tileHexStatesPartialSchema = createNumericKeyRecordSchema(tileHexStatePartialSchema, {
    requireAtLeastOneEntry: true,
})
export type TileHexStatesPartial = z.infer<typeof tileHexStatesPartialSchema>

export function validateTileHexStatesPartial(data: unknown) {
    return validateState(tileHexStatesPartialSchema, data)
}
